import React, { useEffect, useState } from 'react';
import { DAYS } from '../utils/Constants';
import { toast } from 'react-toastify';

type TInputboxProps = {
    label: string;
    showAdditionalLabel?: boolean;
    onChange: (value: number) => void;
    initialValue?: number;
}

const InputboxLabel = ({ label, showAdditionalLabel = false, onChange, initialValue = 0 }: TInputboxProps) => {

    const [value, setValue] = useState<number>(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        if (newValue === '' || newValue === '0') {
            toast.warning('Set duration should be greater than 0');
        }
        setValue(newValue === '' ? 0 : parseFloat(newValue));
        onChange(newValue === '' ? 0 : parseFloat(newValue));
    };

    return (
        <div>
            <div className='tw-flex tw-items-center tw-gap-1'>
                <label className="text-caption-style">{label}</label>
                <span className="tw-text-red-500">*</span>
            </div>
            <div className='tw-flex tw-items-center tw-gap-3 tw-mt-2'>
                <input type="number" className="shadow-none drop-down-dm tw-ps-2 tw-w-32" value={value.toString()} min={1} onChange={handleChange} />
                {showAdditionalLabel ? <label className=''>{Math.abs(value) <= 1 ? 'DAY'  : DAYS}</label> : null}
            </div>
        </div>
    );
}

export default InputboxLabel;